import script from "./NotacoesView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotacoesView.vue?vue&type=script&setup=true&lang=js"

import "./NotacoesView.vue?vue&type=style&index=0&id=0a1a4110&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1a4110"]])

export default __exports__